import { tw } from '~/utils/tw';

/** Row tint for '=' highlight matches in the tasks table and the labels panel. */
export const searchHighlightRowClass = tw('bg-green-300/20 hover:bg-green-300/30');
